import type { AccountInfo } from '../api/types';
import type { ConsentableService } from './services';

/** Entries enabled for this shop. Empty until /accounts/info has loaded. */
export function activeServices(
  registry: readonly ConsentableService[],
  accountInfo: AccountInfo | undefined,
): ConsentableService[] {
  if (!accountInfo) return [];
  return registry.filter((s) => s.isEnabledFor(accountInfo));
}

/**
 * vanilla-cookieconsent's `revision`: when it changes, visitors who already
 * answered are asked again. OR-ing fixed per-service bits means enabling a new
 * service in a shop re-prompts exactly once, and disabling one never does.
 */
export function revisionFor(active: readonly ConsentableService[]): number {
  return active.reduce((acc, s) => acc | s.revisionBit, 0);
}
